<ng-container>
  <form *ngIf="createUserMessageForm" [formGroup]="createUserMessageForm">
    <ion-row *ngIf="userMessage" class="user-message-container">
      <ion-title>Post A Note</ion-title>
      <img class="post-it-icon-image" src="/assets/icon-postit-lg@2x.png" alt="" />
    </ion-row>
    <div class="message-recipient-group" role="radiogroup" aria-label="Post note recipient">
      <label class="message-recipient-option">
        <input
          class="message-recipient-radio"
          type="radio"
          formControlName="messageType"
          value="user"
          (change)="selectMessageType('user')"
        />
        <span class="message-to-label"
          ><strong>To:</strong> {{ teamMember.teamMemberFirstName }} {{ teamMember.teamMemberLastName }}</span
        >
      </label>
      <label class="message-recipient-option">
        <input
          class="message-recipient-radio"
          type="radio"
          formControlName="messageType"
          value="team"
          (change)="selectMessageType('team')"
        />
        <span class="message-to-label"><strong>To:</strong> Dashboard Message</span>
      </label>
    </div>
    <span class="message-label"><strong>Message:</strong></span>
    <ion-textarea
      (ionChange)="onTextAreaChange($event)"
      [autoGrow]="true"
      class="user-message-textarea"
      formControlName="messageBody"
      placeholder="Leave Your Message Here"
    ></ion-textarea>
    <span class="max-characters" *ngIf="messageType == 'user'">{{ characters }} of {{ maxCharacters }} characters</span>
    <div class="button-container">
      <button class="secondary button" type="button" (click)="dismiss()">Cancel</button>
      <button
        [disabled]="isSubmitting || createUserMessageForm.invalid || (messageType == 'user' && characters > maxCharacters)"
        class="primary button send-button"
        type="button"
        (click)="sendTheMessage()"
      >
        Send
      </button>
    </div>
  </form>
</ng-container>
